/**
 * Machine controls on the control plane (ADR 0106 decision 2; R-ND-2, R-TP): "Disable new work"
 * (the scheduler's drain, same routes and shapes as the hub's scheduler module) and a display
 * name, for a server that runs no scheduler module. state.ext['machine-controls'].
 *
 *   POST  /api/scheduler/nodes/:machineId/drain   { reason? }  no new work, running work finishes (operator)
 *   POST  /api/scheduler/nodes/:machineId/resume              take new work again (operator)
 *   PATCH /api/machines/:machineId                { name }     display name (admin, as on the hub)
 */
import type { Id, Ts } from '../index.ts';

export const MACHINE_CONTROLS_EXT = 'machine-controls';

/** Who disabled new work on a machine, when, and why (the scheduler's NodeSettings['drain']). */
export interface MachineDrain {
  at: Ts;
  by: string;
  reason: string;
}

export interface MachineControlsState {
  /** Disabled machines only. */
  drains: Record<Id, MachineDrain>;
}

/** The actions that start work: a disabled machine refuses each. */
export const WORK_STARTING_ACTIONS = ['session.start', 'job.run', 'project.add', 'pipeline.resume', 'pipeline.restart'] as const;

/** The refusal a disabled machine gives an action that starts work. */
export function disabledRefusal(name: string, d: MachineDrain): string {
  return `${name} is disabled for new work (by ${d.by}${d.reason ? `: ${d.reason}` : ''}), so nothing new starts on it. Enable it in Machines, or pick another machine.`;
}
